import materialTheme from "./material";
import grayscaleTheme from "./grayscale";

export default {
  material: materialTheme,
  grayscale: grayscaleTheme
};